import { Link } from "react-router-dom";
import { Fence, ArrowRight } from "lucide-react";

export const PromoBanner = () => (
  <Link
    to="/services/fencing"
    data-testid="promo-banner"
    className="group block bg-[var(--apex-accent)] hover:bg-[var(--apex-accent-dark)] transition-colors"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3.5 flex items-center justify-center gap-3 text-white text-center flex-wrap">
      <Fence size={18} className="shrink-0" />
      <span className="font-bold text-sm sm:text-base uppercase tracking-wide">Vinyl Fence Special</span>
      <span className="text-sm sm:text-base opacity-95">— $69 per linear foot, installed. 6' high premium vinyl, all-inclusive. Free estimate.</span>
      <span className="inline-flex items-center gap-1 font-semibold text-sm underline underline-offset-2 group-hover:gap-2 transition-all">
        Learn more <ArrowRight size={15} />
      </span>
    </div>
  </Link>
);
